import { consultationOfflineStore, OfflineConsultation } from '@/core/offline'
import { useOfflineMode } from '@/providers/OfflineModeProvider'
import { useEffect, useState } from 'react'

export function useOfflineConsultationsLoader() {
  const { isOfflineDatabaseReady } = useOfflineMode()

  const [consultations, setConsultations] = useState<OfflineConsultation[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function loadConsultations() {
      try {
        setLoading(true)
        const allConsultations = await consultationOfflineStore.getAll()
        setConsultations(allConsultations)
      } catch (error) {
        console.error('Error loading offline consultations:', error)
        // TODO: Add error handling UI
      } finally {
        setLoading(false)
      }
    }

    if (isOfflineDatabaseReady) {
      loadConsultations()
    }
  }, [isOfflineDatabaseReady])

  return {
    consultations,
    isOfflineDatabaseReady,
    loading,
  }
}
